import {HalContext} from "@cm/hal/hal-context"
import {HalPainter} from "@cm/hal/hal-painter/index"
import {HalPainterSourceImage, HalPainterTarget} from "@cm/hal/hal-painter-primitive/index"
import {TextureEditorSettings} from "@app/textures/texture-editor/texture-editor-settings"
import {HalPainterImageBlitOptions} from "@cm/hal"
import {HalPainterImageBlitRef} from "@cm/hal/hal-ref"

export class HalPainterImageStretch implements HalPainter {
    constructor(readonly context: HalContext) {
        this.blit = this.context.createHalPainterImageBlit(COMPOSITING_FUNCTION)
    }

    dispose(): void {
        if (!this.blit) {
            throw new Error("HalPainterImageStretch: Already disposed")
        }
        this.blit.release()
        this.blit = null
    }

    paint(target: HalPainterTarget, sourceImage: HalPainterSourceImage, options?: HalPainterImageBlitOptions) {
        if (!this.blit) {
            throw new Error("HalPainterImageStretch: Already disposed")
        }
        this.blit.ref.paint({
            target,
            sourceImages: sourceImage,
            options,
        })
    }

    public static create(context: HalContext): HalPainterImageStretch {
        return new HalPainterImageStretch(context)
    }

    private blit: HalPainterImageBlitRef | null
}

const COMPOSITING_FUNCTION = `
    vec4 computeColor(ivec2 targetPixel, ivec2 sourcePixel, int lod, int addressMode) {
        ${
            TextureEditorSettings.InterpolateStretchBlit
                ? `
        float mipLevelScale = 1.0 / float(1 << lod);
        return textureLodPx0((vec2(targetPixel) + 0.5) * mipLevelScale, lod, addressMode);
        `
                : `
        return texelFetchLod0(targetPixel >> lod, lod, addressMode);
        `
        }
    }
`
